<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Amostras</h3>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-6">
              <h6 class="m-0">Amostras por orçamento</h6>
            </div>
            <div class="col-6">
              <form class="w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Nome da empresa, ID de orçamento"
                    aria-label="Search"
                    v-model="pagination.search"
                  />
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <sample-by-quotation-table :quotations="quotations.list"/>
            </div>
            <pagination
              :total-items="quotations.total_items"
              :pagination.sync="pagination"
            ></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import SampleByQuotationTable from '../components/SampleByQuotationListTable.vue';

export default {
  name: 'sample-by-quotation-list',
  components: {
    Pagination,
    SampleByQuotationTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        sample: true,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    quotations() {
      const { quotationList } = this.$store.state.quotation;
      if (quotationList && quotationList.list.length) {
        return quotationList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getQuotationList',
    ]),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getQuotationList(this.pagination)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },
  beforeDestroy() {
    Events.$off('update:pagination');
  },
};
</script>
